import { transition, trigger, query, style, animate, group } from '@angular/animations';

const slideLeft = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [
      style({ transform: 'translateX(100%)' }),
      animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
    ], { optional: true }),
    query(':leave', [
      style({ transform: 'translateX(0%)' }),
      animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
    ], { optional: true }),
  ])
];

const slideRight = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [
      style({ transform: 'translateX(-100%)' }),
      animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
    ], { optional: true }),
    query(':leave', [
      style({ transform: 'translateX(0%)' }),
      animate('0.5s ease-in-out', style({ transform: 'translateX(100%)' }))
    ], { optional: true }),
  ])
];

export const RouterAnimation =
  trigger('routerAnimations', [
    // transition('HOME => *', slideLeft),
    transition('HOME => PI', slideLeft),
    transition('HOME => DT', slideLeft),
    transition('HOME => GS', slideLeft),
    transition('HOME => DR', slideLeft),

    // transition('* => HOME', slideRight),
    transition('PI => HOME', slideRight),
    transition('DT => HOME', slideRight),
    transition('GS => HOME', slideRight),
    transition('DR => HOME', slideRight),

    transition('PI => DT', slideLeft),
    transition('PI => GS', slideLeft),

    transition('DT => PI', slideRight),
    transition('DT => GS', slideLeft),

    transition('GS => PI', slideRight),
    transition('GS => DT', slideRight),

    // transition('* => DR', slideLeft),
    transition('PI => DR', slideLeft),
    transition('DT => DR', slideLeft),
    transition('GS => DR', slideLeft),

    // transition('DR => *', slideRight),
    transition('DR => PI', slideRight),
    transition('DR => DT', slideRight),
    transition('DR => GS', slideRight),

    // transition('* => OTHER', slideLeft),
    transition('HOME => OTHER', slideLeft),
    transition('PI => OTHER', slideLeft),
    transition('DT => OTHER', slideLeft),
    transition('GS => OTHER', slideLeft),
    transition('DR => OTHER', slideLeft),

    // transition('OTHER => *', slideRight),
    transition('OTHER => HOME', slideRight),
    transition('OTHER => PI', slideRight),
    transition('OTHER => DT', slideRight),
    transition('OTHER => GS', slideRight),
    transition('OTHER => DR', slideRight)
  ]);
